var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowPercentDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.07812 10.5859L1.14062 6.46094C0.929688 6.22656 0.929688 5.875 1.16406 5.66406C1.39844 5.45312 1.75 5.45312 1.96094 5.6875L4.9375 8.80469V0.8125C4.9375 0.507812 5.17188 0.25 5.5 0.25C5.80469 0.25 6.0625 0.507812 6.0625 0.8125V8.80469L9.01562 5.6875C9.22656 5.45312 9.60156 5.45312 9.8125 5.66406C10.0469 5.875 10.0469 6.22656 9.83594 6.46094L5.89844 10.5859C5.78125 10.7031 5.64062 10.75 5.5 10.75C5.33594 10.75 5.19531 10.7031 5.07812 10.5859Z",
    fill: "#F16A81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowPercentDark);
export default __webpack_public_path__ + "static/media/downArrowPercentDark.e6b9126ebd7ba84825a92a5cd63064fe.svg";
export { ForwardRef as ReactComponent };